/** Imperative Modal.confirm — registered by ConfirmModalProvider on mount */

let confirmImpl = null;

export function registerModalConfirm(fn) {
  confirmImpl = fn || null;
}

export function modalConfirm(opts) {
  if (typeof confirmImpl !== "function") {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.warn("Modal.confirm called before provider mounted");
    }
    return Promise.resolve(false);
  }
  return confirmImpl(opts);
}
